import { render, staticRenderFns } from "./DisplayPdf.vue?vue&type=template&id=2a2f565d&scoped=true"
import script from "./DisplayPdf.vue?vue&type=script&lang=js"
export * from "./DisplayPdf.vue?vue&type=script&lang=js"
import style0 from "./DisplayPdf.vue?vue&type=style&index=0&id=2a2f565d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f565d",
  null
  
)

export default component.exports